
<template>
    <div class="showcase-image">
        <img
            class="showcase-image__image"
            :src="'/images/esignature/secure-signing.svg'" />

    </div>

</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

 .showcase-image {
    display: flex;
    flex: 1 1 auto;
    flex-flow: column;
    align-items: center;
    margin-top: 22vh;

    &__image {
        width: 27.875rem;
        height: 23.00256rem;
        margin-bottom: 0.69rem;
    }
}
</style>